import * as React from "react";
import { viewDateTimeUtc } from "src/common/formats";
import { AttrData } from "../AttributeHistrory.types";

export const AttrDateTime: React.FC<AttrData> = ({ value }) =>
  viewDateTimeUtc(value, "DD.MM.YYYY HH.mm.ss");
